import React from 'react';
import styled from '@emotion/styled';
import breakpoints from '../../theme/material/breakpoints';
import { StarIcon } from '../icons/favoriteIcons';

const StyledCardBanner = styled('div')<{ customBackground?: string; children: React.ReactNode }>(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: '6px 0',
    width: '100%',

    zIndex: 5,
    display: 'flex',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '15px',
    letterSpacing: '-0.3px',
    opacity: 0.9,
    color: '#fff',
    svg: {
      width: 14,
      height: 14,
      marginTop: 1,
      marginRight: 4,
    },
    [breakpoints.down(639.05)]: {
      fontSize: 12,
      svg: {
        height: 12,
      },
    },
  },
  ({ customBackground }) => ({
    background: `${customBackground ? customBackground : '#E21D4A'}`,
  })
);

interface ProfileCardBannerProps {
  isMatched: boolean;
  isFavoritedMe: boolean;
}

const ProfileCardBanner: React.FC<ProfileCardBannerProps> = ({ isMatched, isFavoritedMe }) => {
  if (isMatched) {
    return (
      <StyledCardBanner data-test-id="fav-banner-mutual-favorite">
        <StarIcon isActive={false} fill="#FFF" /> Mutual Favorite!
      </StyledCardBanner>
    );
  }

  if (isFavoritedMe) {
    return (
      <StyledCardBanner data-test-id="fav-banner-favorited-you">
        <StarIcon isActive={false} fill="#FFF" /> Favorited You!
      </StyledCardBanner>
    );
  }

  return null;
};

export default React.memo(ProfileCardBanner);
